import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},

    body: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        minHeight: 0,
        width: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-start',
        overflow: 'hidden',
    },

    footer:{
        display: 'flex',
        flex: '0 0 60px',
        padding: '12px 24px 16px',
        justifyContent: 'end',
        alignItems: 'center',
        alignSelf: 'stretch',
    },

    selectorControls:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },

    backButton:{
        display: 'flex',
        height: 40,
        minWidth: 40,
        padding: '0 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        borderRadius: 4,
        background: theme.colors.tab_white,
        borderWidth: 0,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,

        '&:hover':{
            background: theme.colors.tab_white,
        },
    },

    loader: {
        color: theme.colors.violet_primary,
    },
}));
